import { graphql } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../contexts/franchise/microsite-context.tsx';
import SiteSearchBar from "../organisms/site-search-input";
import Link from "../primitives/link";
import { colors } from '../primitives/colors/index.tsx';

const QuicklinksAlt = ({ data }) => {
    const { isMicrosite, ...microsite } = useMicrosite();
    const { heading, links } = data;

    if (!links || links.length === 0) {
        return null;
    }

    return (
        <div css={styles.quickLinksSection}>
            <h2 css={styles.heading}>{heading}</h2>
            <div css={styles.LinksWrap}>
                {links && links.length > 0 && links.map((link) => {
                    if (!link?.href) {
                        return null;
                    }
                    if (isMicrosite && microsite?.bannedInternalLinks.includes(link.href)) {
                        return null;
                    }
                    return (
                        <Link css={styles.link} key={link.title} to={link.href}>
                            {link.title}
                        </Link>
                    );
                })}
            </div>
            {!isMicrosite && (
                <div css={styles.searchbarGroup}>
                    <p css={styles.searchbarTitle}>Have another question?</p>
                    <div>
                        <SiteSearchBar />
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = {
    link: {
        textDecoration: "underline",
        transition: "color 300ms cubic-bezier(0.4, 0, 0.2, 1)",
        ":hover": {
            color: colors.primaryOrangeHover
        }
    },
    quickLinksSection: {
        position: "relative",
        left: "0",
        zIndex: 20,
        paddingTop: "3rem",
        width: "100%",
        fontSize: "1.125rem",
        lineHeight: "1.75rem",
        "@media (min-width: 1024px)": {
            paddingBottom: "1rem",
            paddingTop: "3rem",
            paddingLeft: "6rem"
        }
    },
    heading: {
        color: colors.shadesBlack,
        marginBottom: "1.25rem",
        fontSize: "1.5rem",
        lineHeight: "2rem",
        fontWeight: 600,
        "@media (min-width: 640px)": {
            paddingLeft: "2rem",
            paddingRight: "2rem"
        }
    },
    LinksWrap: {

        color: colors.primaryOrange,
        display: "flex",
        marginBottom: "1.75rem",
        flexDirection: "column",
        alignItems: "flex-start",
        marginBottom: "37px",
        ">:not([hidden])~:not([hidden])": {
            marginTop: '1.25rem'
        },
        "@media (min-width: 640px)": {
            paddingLeft: "2rem",
            paddingRight: "2rem"
        },
        "@media (min-width: 1024px)": {
            fontSize: "21px"
        },
    },
    searchbarGroup: {
        borderRadius: "5px",
        paddingLeft: "2rem",
        paddingRight: "2rem",
        paddingTop: "1.25rem",
        paddingBottom: "2rem",
        backgroundColor: colors.shadesBlack
    },
    searchbarTitle: {
        marginBottom: "0.5rem",
        color: colors.shadesWhite,
        letterSpacing: '1.2px'
    }
};

export const query = graphql`
  fragment QuicklinksData on CmsPageBuilderBlocks {
    quicklinks {
      heading
      links {
        href
        title
      }
    }
  }
`;

export default QuicklinksAlt;
